import { AdditionalType, Tourney } from '../../../model/interfaces';
import React, { FC } from 'react';
import {
  months,
  startIn,
} from '../../tournamentsAdditionalInfo/tournamentsAdditionalInfo';

type PropsType = {
  item: Tourney;
  children?: never;
  handlerShowAdditional: (id: string, data: AdditionalType) => void;
  activeItem: string;
};

export const FinishedTournamentsItem: FC<PropsType> = ({
  item,
  handlerShowAdditional,
  activeItem,
}: PropsType) => {
  const { TourneyID, StartTimeUTC, Name, DirectorName, EntryFee } = item;
  const time = startIn(StartTimeUTC.toString());
  const minutes =
    new Date(time).getMinutes() < 10
      ? `${new Date(time).getMinutes()}0`
      : new Date(time).getMinutes();
  const timeStart = `${months[new Date(time).getMonth()]} ${new Date(
    time
  ).getDate()}, ${new Date(time).getHours()}:${minutes}`;

  const addData: AdditionalType = {
    tourneyID: item.TourneyID,
    component: 'finished',
    directorName: item.DirectorName,
    directorId: item.Director,
    startTime: timeStart,
    checkIn: '5min prior to start',
    pairing: item.PairingType,
    timeControl: item.TimeControl,
    entryFee: item.EntryFee,
    description: item.Description,
    extraBonus: item.ExtraBonus,
    firstPrizeUsr: item.FirstPrizeUsr,
    firstPrizeAmt: item.FirstPrizeAmt,
    secondPrizeUsr: item.SecondPrizeUsr,
    secondPrizeAmt: item.SecondPrizeAmt,
    thirdPrizeUsr: item.ThirdPrizeUsr,
    thirdPrizeAmt: item.ThirdPrizeAmt,
    fourthPrizeUsr: item.FourthPrizeUsr,
    fourthPrizeAmt: item.FourthPrizeAmt,
  };

  const activeClass =
    activeItem === TourneyID
      ? 'finished__content finished__content--active'
      : 'finished__content';

  return (
    <div
      className={activeClass}
      onClick={() => {
        handlerShowAdditional(TourneyID, addData);
      }}
    >
      <div className="tournaments__item-title">{timeStart}</div>
      <div className="tournaments__item-rules">{Name}</div>
      <div className="tournaments__item-director">
        <div className="avatar-overlay">
          <img
            className="avatar"
            src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${item.Director}&size=2`}
            alt="avatar"
          />
        </div>
        <div className="tournaments__item-director-name">{DirectorName}</div>
      </div>
      <div className="tournaments__item-entry">{`${EntryFee} Tickets`}</div>
      <div className="tournaments__item-reward">
        <div>{`1st: ${addData.firstPrizeAmt} T`}</div>

        {addData.secondPrizeAmt !== '0.00' && (
          <div>{`2st: ${addData.secondPrizeAmt} T`}</div>
        )}
        {addData.thirdPrizeAmt !== '0.00' && (
          <div>{`3st: ${addData.thirdPrizeAmt} T`}</div>
        )}
        {addData.fourthPrizeAmt !== '0.00' && (
          <div>{`4st: ${addData.fourthPrizeAmt} T`}</div>
        )}
      </div>
    </div>
  );
};
